import { render, staticRenderFns } from "./RX.vue?vue&type=template&id=15c0c1ae&"
import script from "./RX.vue?vue&type=script&lang=js&"
export * from "./RX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports